import React from 'react'

const Floatingbutton = ({onOpen = () => {}}) => {
  return (
    <button 
    type='button'
    className='btn rounded-circle position-fixed d-flex align-items-center justify-content-center shadow' style={{
     width: "56px",
    height: "56px",
    bottom: "74px",
    right: "31px",
    fontSize: "30px",
    backdropFilter: "blur(10px)",
    backgroundColor: "#24265d ",
    color: "white",
    border: "none",
    cursor: "pointer",
    zIndex: 1050,
    }}
    onClick={()=> onOpen()}
    >  
    +
    </button>
    
  )
}

export default Floatingbutton
